import { useFeatureFlag } from '@artic/ui/feature-flags';
import { createFileRoute } from '@tanstack/react-router';

import { usePartnerId, usePartnerName } from '../../features/inbox/use-partner-name';
import { OperationsList } from '../../features/operations/operations-list';

export const Route = createFileRoute('/operations/')({
  // Parent /operations route already contributes the "Operations"
  // crumb — the index inherits it without re-emitting a duplicate.
  staticData: {
    layout: 'full-height',
  },
  component: OperationsListPage,
});

function OperationsListPage() {
  // Operations management is part of the planner suite.
  const enabled = useFeatureFlag('planner');
  const partnerId = usePartnerId();
  const partnerName = usePartnerName();

  if (!enabled) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-20">
        <h2 className="text-lg font-semibold">Feature not available</h2>
        <p className="text-muted-foreground text-sm">
          Operations management in Quality is not enabled for your organisation.
        </p>
      </div>
    );
  }

  return <OperationsList partnerId={partnerId} partnerName={partnerName} />;
}
